/* deferred-init.js — inits não-críticos disparados após window.load via requestIdleCallback.
   Removidos do DOMContentLoaded do app.min.js para reduzir TBT mobile. */
(function () {
  function run() {
    try {
      // Accordions do footer (abaixo do fold — diferidos do DOMContentLoaded)
      if (window.utils) {
        window.utils.createAccordion('.footer_menu', 'h6', 'ul');
        window.utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
      }
      window.testimonials && window.testimonials.init();
      window.video && window.video.init();
      window.gallery && window.gallery.init();
      window.videoFeature && window.videoFeature.setupVideoPlayer();
      window.featuredPromotions && window.featuredPromotions.init();
      window.logoList && window.logoList.init();
      window.map && window.map.init();
      window.shoppableImage && window.shoppableImage.init();
      window.recentlyViewed && window.recentlyViewed.init();
      typeof window.lazyframe === 'function' && window.lazyframe('.lazyframe');
      if (window.PXUTheme && window.PXUTheme.theme_settings.enable_back_to_top_button) {
        window.back_to_top_button && window.back_to_top_button.init();
      }
      if (window.PXUTheme && window.PXUTheme.media_queries.large.matches) {
        if (typeof $ !== 'undefined' && typeof $.fn.waypoint !== 'undefined') {
          $('.animate_right').waypoint(function () { $(this.element).addClass('animated fadeInRight'); }, { offset: '70%' });
          $('.animate_left').waypoint(function () { $(this.element).addClass('animated fadeInLeft'); }, { offset: '70%' });
          $('.animate_up').waypoint(function () { $(this.element).addClass('animated fadeInUp'); }, { offset: '70%' });
          $('.animate_down').waypoint(function () { $(this.element).addClass('animated fadeInDown'); }, { offset: '70%' });
        }
      }
    } catch (e) {}
  }

  function schedule() {
    'requestIdleCallback' in window
      ? requestIdleCallback(run, { timeout: 2000 })
      : setTimeout(run, 200);
  }

  document.readyState === 'complete' ? schedule() : window.addEventListener('load', schedule);
})();
